import { getRequest, postRequest } from "../fetchWrapper";

/**
 * Récupération de la liste des documents côté admin.
 *
 * @param {string} token - Jeton d'authentification.
 * @param {number} pageNumber - Numéro de la page.
 * @param {number} itemsPerPage - Nombre d'éléments par page.
 * @param {string} keywords - Mots-clés de recherche.
 * @returns {Promise<Response|null>} Réponse de la requête à l'API.
 */
export const getAdminDocumentList = (token, pageNumber, itemsPerPage, keywords) => {
    const url = `/api-v1/admin/document/${pageNumber}/${itemsPerPage}/${keywords}/list`;
    return getRequest(url, token);
};

/**
 * Récupération de la liste des documents côté pro.
 *
 * @param {string} token - Jeton d'authentification.
 * @returns {Promise<Response|null>} Réponse de la requête à l'API.
 */
export const getDocumentList = (token) => {
    const url = `/api-v1/document/list`;
    return getRequest(url, token);
};

/**
 * Récupération des informations d'un document côté admin.
 *
 * @param {string} token - Jeton d'authentification.
 * @param {number} id - Identifiant du document.
 * @returns {Promise<Response|null>} Réponse de la requête à l'API.
 */
export const getDocumentInfos = (token, id) => {
    const url = `/api-v1/admin/document/${id}/infos`;
    return getRequest(url, token);
};

/**
 * Upload ou mise à jour d'un document côté admin.
 * Cette fonction unifiée gère à la fois la création et la mise à jour des documents.
 *
 * @param {string} token - Jeton d'authentification.
 * @param {Object} body - Données du document (name, description, file, url, type, id).
 * @param {number} id - Identifiant du document (0 pour création, >0 pour mise à jour).
 * @returns {Promise<Response|null>} Réponse de la requête à l'API.
 */
export const uploadDocument = (token, body, id) => {
    const url = `/api-v1/admin/document/update`;
    return postRequest(url, body, token);
};

/**
 * Mise à jour des informations d'un document côté admin.
 * @deprecated Utiliser uploadDocument à la place (fonction unifiée).
 *
 * @param {string} token - Jeton d'authentification.
 * @param {Object} body - Données du document.
 * @returns {Promise<Response|null>} Réponse de la requête à l'API.
 */
export const updateDocumentInfos = (token, body) => {
    const url = `/api-v1/admin/document/update`;
    return postRequest(url, body, token);
};

/**
 * Suppression d'un document côté admin.
 *
 * @param {string} token - Jeton d'authentification.
 * @param {number} id - Identifiant du document.
 * @returns {Promise<Response|null>} Réponse de la requête à l'API.
 */
export const deleteDocumentFromDb = (token, id) => {
    const url = `/api-v1/admin/document/delete`;
    return postRequest(url, id, token);
};

/**
 * Mise à jour de la visibilité d'un document côté admin.
 *
 * @param {string} token - Jeton d'authentification.
 * @param {Object} body - Corps de la requête contenant l'id et le statut.
 * @returns {Promise<Response|null>} Réponse de la requête à l'API.
 */
export const updateDocumentEnable = (token, body) => {
    const url = `/api-v1/admin/document/enable`;
    return postRequest(url, body, token);
};

/**
 * Récupération de la liste des types de documents côté admin.
 *
 * @param {string} token - Jeton d'authentification.
 * @returns {Promise<Response|null>} Réponse de la requête à l'API.
 */
export const getDocumentTypeList = (token) => {
    const url = `/api-v1/admin/document/type/list`;
    return getRequest(url, token);
};